// i18n.config.ts
// import en from './locales/en'
// import zhTW from './locales/zh-TW'

export default defineI18nConfig(() => ({
    legacy: false,
    locale: 'en',
    fallbackLocale: false,  // 停用回退語言，避免載入額外的語言包
    silentFallbackWarn: true,
    silentTranslationWarn: true,
}))